<div class="frame-solid wj-tabpane" id="vw_ImageInfoDetail">

  <div class="block-row">
    <div class="image-container">
      <img id="img_GoodsImage" src="{{this.goodsImagePreviewURL}}">
    </div>

    <app-kymw5002-image-info-detail-box id="imageInfoDetailBox" #imageInfoDetailBox forcedEnabledMode="true" [style.width.%]="100">
    </app-kymw5002-image-info-detail-box>
  </div>

  <!-- 画像情報詳細エリア ここまで-->
</div>
